import React, { FC, useEffect } from 'react';
import { IAccount } from '@entities/account/IAccount';
import { IAccountFormValuesEdit } from '@pages/Account/Edit';
import TextForm from '@shared/form/TextForm';
import { Controller, useFieldArray } from 'react-hook-form';
import Label from '@shared/uikit/label';
import { CollectionForm, CollectionFormItem } from '@shared/form/CollectionForm';
import SingleSelectForm from '@shared/form/SingleSelectForm';
import { ISelectOption } from '@widgets/multi-select';
import { IAccountEditOptions } from '@pages/Account/hooks/useAccountEditOptions';
import { resolveAccountTypeTitle } from '@pages/Account/helpers/accountTypeHelper';
import LabelVerticalForm from '@shared/form/VerticalLabelForm';

interface IProps {
  account: IAccount;
  control: any;
  options: IAccountEditOptions;
}

export const DEFAULT_AGENCY_ACCOUNT = { account: null, cashback: '' };

export interface IReferralAccountTypeFormValuesEdit {
  discount: number;
  agents: { account: ISelectOption | null; cashback: number }[];
}

export const fillReferralAccountDefault = (
  account: IAccount
): IReferralAccountTypeFormValuesEdit => {
  let agents = account.agents.map(agent => ({
    account: { value: agent.account, label: agent.account },
    cashback: agent.cashback,
  }));

  return {
    discount: account.discount,
    // agents: [...agents, DEFAULT_AGENCY_ACCOUNT]
    agents: agents,
  };
};

const ReferralAccountTypeEdit: FC<IProps> = ({ account, control, options }) => {
  useEffect(() => {
    if (0 === agencyAccountFields.length) {
      agencyAccountAppend(DEFAULT_AGENCY_ACCOUNT);
    }
  }, [account]);

  const {
    fields: agencyAccountFields,
    append: agencyAccountAppend,
    remove: agencyAccountRemove,
  } = useFieldArray({
    control,
    name: `agents`,
  });

  return (
    <>
      <div className="grid grid-cols-[1fr_1fr] justify-items-start items-center">
        <Controller
          name="discount"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Комиссия пула" color="white" />
              <div className="w-full flex items-center gap-2 text-white">
                <div className="ml-auto w-[60px]">
                  <TextForm
                    value={field.value}
                    onChange={val => {
                      field.onChange(val);
                    }}
                    placeholder=""
                    state={fieldState}
                    type="number"
                  />
                </div>
                %
              </div>
            </>
          )}
          rules={{
            required: true,
            pattern: {
              value: /^(\d{1,2}|100)(?:[.,]\d+)?$/,
              message: 'Only numbers are allowed',
            },
          }}
        />
      </div>
      <CollectionForm>
        {agencyAccountFields.map((field, index) => {
          return (
            <div className="flex flex-row justify-items-start items-center pt-[15px] border-t border-solid border-opacity-10 border-[#959595]">
              <CollectionFormItem
                key={field.id}
                onCreate={() => agencyAccountAppend(DEFAULT_AGENCY_ACCOUNT)}
                onRemove={() => agencyAccountRemove(index)}
                index={index}
              >
                <div className="w-full grid grid-cols-[38%_auto] gap-3 justify-items-start items-center">
                  <Controller
                    name={`agents.${index}.account`}
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <Label title="Агентский аккаунт" color="white" />
                        <div className="w-[100%]">
                          <SingleSelectForm
                            placeholder="Аккаунт"
                            isLoading={false}
                            options={options.accountOptions}
                            width="100%"
                            onChange={(val: ISelectOption | null) => {
                              field.onChange(val);
                            }}
                            value={field.value}
                            state={fieldState}
                            isCreatable={true}
                          />
                        </div>
                      </>
                    )}
                    rules={{ required: true }}
                  />
                  <Controller
                    name={`agents.${index}.cashback`}
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <Label title="Кэшбэк" color="white" />
                        <div className="w-full flex items-center gap-2 text-white">
                          <div className="ml-auto w-[60px]">
                            <TextForm
                              value={field.value ?? ''}
                              onChange={val => {
                                field.onChange(val);
                              }}
                              placeholder=""
                              state={fieldState}
                              type="number"
                            />
                          </div>
                          %
                        </div>
                      </>
                    )}
                    rules={{
                      required: true,
                      pattern: {
                        value: /^(\d{1,2}|100)(?:[.,]\d+)?$/,
                        message: 'Only numbers are allowed',
                      },
                    }}
                  />
                </div>
              </CollectionFormItem>
            </div>
          );
        })}
      </CollectionForm>
    </>
  );
};

export default ReferralAccountTypeEdit;
